import React from 'react';
import { Spin } from 'antd';
const Loader = () => (
  <div className="example">
    <Spin />
  </div>
);
export default Loader;